import { ApolloError } from "@apollo/client";
import { useEffect, useMemo, useRef } from "react";
import { MessageDescriptor, useIntl } from "react-intl";

import { intlApolloError } from "./utils";

const useIntlApolloError = (
  messages: Record<string, string | MessageDescriptor>,
  error?: ApolloError
): ApolloError | undefined => {
  const intl = useIntl();
  const messagesRef = useRef(messages);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  return useMemo(
    () => intlApolloError(intl, messagesRef.current, error),
    [error, intl]
  );
};

export default useIntlApolloError;
